<!-- reddi-edit-round-modal.component.html -->
<div class="reddi-edit-modal-container">
  <div class="mat-headline-4 reddi-edit-text-container">Edit REDDI Round</div>
  <mat-dialog-content class="reddi-edit-modal-dropdowns">
    <app-dropdown
      [control]="distanceControl"
      [data]="distances"
      label="Distance"
      [required]="true"
      errorText="Distance is required"
    ></app-dropdown>
    <app-dropdown
      [control]="listeningConditionsControl"
      [data]="listeningConditions"
      label="Listening Conditions"
      [required]="true"
      errorText="Listening Condition is required"
    ></app-dropdown>
    <app-dropdown
      [control]="volumeControl"
      [data]="volumes"
      label="Volume"
      [required]="true"
      errorText="Volume is required"
    ></app-dropdown>
    <app-dropdown
      [control]="cuesControl"
      [data]="cues"
      label="Cues"
      [required]="true"
      errorText="Cues is required"
    ></app-dropdown>
    <app-dropdown
      [control]="mResponseControl"
      [data]="responses"
      label="m"
    ></app-dropdown>
    <div *ngIf="data.roundData && !ignoreSound2">
      <app-dropdown
        [control]="orResponseControl"
        [data]="responses"
        label="or"
      ></app-dropdown>
    </div>
    <app-dropdown
      [control]="ooResponseControl"
      [data]="responses"
      label="oo"
    ></app-dropdown>
    <app-dropdown
      [control]="ahResponseControl"
      [data]="responses"
      label="ah"
    ></app-dropdown>
    <app-dropdown
      [control]="eeResponseControl"
      [data]="responses"
      label="ee"
    ></app-dropdown>
    <app-dropdown [control]="shResponseControl" [data]="responses" label="sh">
    </app-dropdown>
    <app-dropdown [control]="sResponseControl" [data]="responses" label="s">
    </app-dropdown>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="reddi-edit-modal-actions">
      <button mat-button (click)="onCancel()">Cancel</button>
      <app-action-button
        color="primary"
        kind="filled"
        size="standard"
        type="button"
        (onClick)="onSubmit()"
        >Submit
      </app-action-button>
    </div>
  </mat-dialog-actions>
</div>
